// extracted by mini-css-extract-plugin
export default {"root":"SetupSubscription_root__34Zfc","periodSwitch":"SetupSubscription_periodSwitch__jKUiX"};